export const VENDOR_RULES_BASED_PRODUCT_TAGS_LEARN_MORE_URL =
    'https://help.sparkplug.app/en/articles/8137481-using-product-tags-to-build-sparks';

export const MULTI_RETAILER_LEARN_MORE_URL =
    'https://help.sparkplug.app/en/articles/8292484-multi-retailer-sparks';
